<template>
    <asli-slideout id="slideout-column-info" v-model="showMoreInfo">
        <div class="p-[30px] text-sm">
            <h2 class="text-[32px] mb-8 font-bold">{{ title }}</h2>
            <div v-if="props.columnKey === TableHeaderKey.HOME_EMERGENCY">
                <ul class="list-disc ml-5">
                    <li v-for="item in homeEmergencyListItems" class="mb-1 last:mb-0">
                        {{ item }}
                    </li>
                </ul>
            </div>
        </div>
    </asli-slideout>
</template>

<script lang="ts" setup>
import { multiTableHeaders } from "@/views/YourQuotes/MultiQuote/constants";
import { TableHeaderKey } from "@/views/YourQuotes/types";
import { AsliSlideout, useModel } from "@mbs-npm/anpost-ui";
import { PropType, computed } from "vue";
const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    columnKey: {
        type: [String, null] as PropType<TableHeaderKey | null>,
        required: true
    }
});
const emit = defineEmits<{
    (e: "update:modelValue", val: boolean): void;
}>();
const showMoreInfo = useModel(props, emit);
const title = computed(() => {
    return multiTableHeaders.find(header => header.id === props.columnKey)?.text;
});
const homeEmergencyListItems = ["24-hour", "365 days-a-year", "Nationwide Emergency Home Rescue Service"];
</script>
